import { Component, Input, OnInit } from '@angular/core';
import * as moment from 'moment-timezone';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'cc-timezones-dropdown',
  templateUrl: './timezones-dropdown.component.html',
  styleUrls: ['./timezones-dropdown.component.scss']
})
export class TimezonesDropdownComponent implements OnInit {
  allTimezones: string[];

  @Input() private initial: string;

  @Input() public formControl: FormControl;

  constructor() {}

  ngOnInit() {
    this.allTimezones = moment.tz.names();
    const timezone = this.initial || moment.tz.guess();
    this.formControl.setValue(timezone);
  }
}
